<template>
  <transition appear name="img-pop-fade">
    <div v-if="!closed" class='img-pop-fullscreen' @click.self="close()" :class="[{multiple: images.length > 1}]">
      <div class="img-pop-container">
        <div class="img-pop-content" @click="close">
          <template v-if="images.length > 1">
            <el-tooltip effect="light" content="上一张" placement="top">
              <div class="img-pop-prev" @click.stop="prev">
                <svg width="25" height="25" viewBox="0 0 1792 1915" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1664 896v128q0 53-32.5 90.5t-84.5 37.5h-704l293 294q38 36 38 90t-38 90l-75 76q-37 37-90 37-52 0-91-37l-651-652q-37-37-37-90 0-52 37-91l651-650q38-38 91-38 52 0 90 38l75 74q38 38 38 91t-38 91l-293 293h704q52 0 84.5 37.5t32.5 90.5z"
                    fill="#fff"></path>
                </svg>
              </div>
            </el-tooltip>
            <el-tooltip effect="light" content="下一张" placement="top">
              <div class="img-pop-next" @click.stop="next">
                <svg width="25" height="25" viewBox="0 0 1792 1915" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1600 960q0 54-37 91l-651 651q-39 37-91 37-51 0-90-37l-75-75q-38-38-38-91t38-91l293-293h-704q-52 0-84.5-37.5t-32.5-90.5v-128q0-53 32.5-90.5t84.5-37.5h704l-293-294q-38-36-38-90t38-90l75-75q38-38 90-38 53 0 91 38l651 651q37 35 37 90z"
                    fill="#fff"></path>
                </svg>
              </div>
            </el-tooltip>
          </template>
          <div class="img-pop-content-inner"><img :src="image.src" :alt="image.name || ''"></div>
        </div>
        <div class="img-pop-thumb-container" v-if="images.length > 1" ref="thumbContainer">
          <div class="img-pop-thumb" v-for="(img, idx) in images" :key="idx" ref="thumb"
               @click="goto(idx)" :class="[{active: index === idx}]">
            <img :src="img.src" :alt="img.name || ''">
          </div>
        </div>
      </div>
      <div class="img-pop-footer clearfix">
        <div class="img-pop-footer-left">
          <div class="img-pop-count" v-if="images.length > 1">
            {{ index + 1}}/{{ images.length }}
          </div>
        </div>
        <div class="img-pop-img-title">{{image.name || ''}}</div>
        <div class="img-pop-footer-right">
          <el-tooltip effect="light" content="保存图片" placement="top">
            <a :href="image.src" :download="image.name || ''" target="_blank">
              <icon name="download"></icon>
            </a>
          </el-tooltip>
          <el-tooltip effect="light" content="新窗口打开" placement="top">
            <a :href="image.src" target="_blank">
              <icon name="external-link"></icon>
            </a>
          </el-tooltip>
          <el-tooltip effect="light" content="关闭" placement="top">
            <div class="img-pop-closer" @click="close">&times;</div>
          </el-tooltip>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import assign from 'lodash/assign'

export default {
  data () {
    return {
      images: [],
      index: 0,
      timeout: 3500,
      closed: true,
      timeout_id: null,
      cancelScrollFunc: null,
    }
  },
  computed: {
    image () {
      return this.images[this.index]
    },
  },
  methods: {
    open (option) {
      assign(this, {index: 0, timeout: 3500}, option)
      if (!this.images || !this.images.length) {
        this.close()
        return
      }
      document.querySelector('body').classList.add('body-img-pop')
      this.closed = false
      window.addEventListener('keyup', this._onKeyup)
      this.$nextTick(() => this._scroll(0))
    },
    close () {
      if (this.closed) return
      document.querySelector('body').classList.remove('body-img-pop')
      this.images = []
      this.index = 0
      this.closed = true
      window.removeEventListener('keyup', this._onKeyup)
      if (this.cancelScrollFunc) {
        this.cancelScrollFunc()
        this.cancelScrollFunc = null
      }
    },
    next () {
      let from = this.index
      if (this.index + 1 < this.images.length) {
        this.index++
      } else {
        this.index = 0
      }
      this._scroll(from)
    },
    prev () {
      let from = this.index
      if (this.index > 0) {
        this.index--
      } else {
        this.index = this.images.length - 1
      }
      this._scroll(from)
    },
    goto (to) {
      let from = this.index
      this.index = to
      this._scroll(from)
    },
    _scroll (from) {
      if (this.images.length <= 1 || from === this.index) return
      let duration = Math.min(500, Math.abs(from - this.index) * 100)
      let option = {container: this.$refs.thumbContainer, offset: -20}
      this.cancelScrollFunc = this.$scrollTo(this.$refs.thumb[this.index], duration, option)
    },
    _onKeyup (e) /* istanbul ignore next */ {
      // esc
      if (e.keyCode === 27) this.close()
      // arrow right
      if (e.keyCode === 39) this.next()
      // arrow left
      if (e.keyCode === 37) this.prev()
    },
  },
  beforeDestroy () /* istanbul ignore next */ {
    this.close()
  },
}
</script>

<style scoped lang="scss">
.img-pop-fullscreen {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  background-color: transparentize(black, 0.3);
  touch-action: none;
  display: flex;
  flex-direction: column;

  $padding: 20px;

  $font-stack: 'Avenir', Helvetica, Arial, sans-serif;

  .img-pop-footer {
    $height: 40px;
    width: 100%;
    text-align: center;
    color: #dcdde2;
    background-color: transparentize(black, 0.7);
    position: relative;
    font-family: $font-stack;
    line-height: $height;
    .img-pop-footer-left, .img-pop-footer-right {
      position: absolute;
      top: 0;
      > * {
        display: block;
        padding: 0 12px;
        float: left;
        > .fa-icon {
          height: 0.5em;
          vertical-align: 0;
        }
      }
    }
    .img-pop-footer-left {
      left: 0;
    }
    .img-pop-footer-right {
      right: 0;
      > * {
        font-size: 2.5rem;
        cursor: pointer;
        transition: color 0.4s ease-in-out;
        color: #dcdde2;
        &:hover {
          color: white;
          background-color: transparentize(black, 0.5);
        }
      }
    }
  }

  .img-pop-prev, .img-pop-next {
    color: white;
    cursor: pointer;
    font-family: $font-stack;
    text-align: center;
    width: 70px;
    height: 90px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: transparentize(black, 0.7);
    z-index: 1000;
    opacity: 0.3;
    transition: opacity 0.3s ease-in-out;
    svg {
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: 60%;
      height: 60%;
      transform: translateY(-50%);
    }
    &:hover {
      opacity: 1;
    }
  }

  .img-pop-prev {
    left: $padding;
  }

  .img-pop-next {
    right: $padding;
  }

  .img-pop-container {
    flex: 1;
    display: flex;
    .img-pop-content {
      flex: 1;
      position: relative;
      .img-pop-content-inner {
        position: absolute;
        top: 5px;
        bottom: 5px;
        left: 5px;
        right: 5px;
        img {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          user-select: none;
        }
      }
    }
    .img-pop-thumb-container {
      $size: 100px;
      $padding: 8px;
      width: $size;
      padding: 0 $padding;
      background-color: transparentize(black, 0.5);
      user-select: none;
      overflow-x: hidden;
      overflow-y: auto;
      .img-pop-thumb {
        width: 100%;
        min-height: $size * .3;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: $padding 0;
        cursor: pointer;
        img {
          max-width: 100%;
          max-height: 100%;
          border: 1px solid transparentize(black, 0.7);
        }
        opacity: 0.6;
        &.active, &:hover {
          opacity: 1;
          img {
            border-color: white;
          }
        }
      }
    }
  }
}

.img-pop-fade-enter, .img-pop-fade-leave-to {
  opacity: 0;
}

.img-pop-fade-enter-active, .img-pop-fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/components/common/img-pop/ImgPop.vue